import { render, staticRenderFns } from "./ConsumersScreen.vue?vue&type=template&id=6623a8ac"
import script from "./ConsumersScreen.vue?vue&type=script&lang=js"
export * from "./ConsumersScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports